export default "__VITE_ASSET__DIvhObE7__"